import { Settings } from "luxon";
Settings.defaultZone = "Europe/Copenhagen";
Settings.defaultLocale = "da";
require("../style/biointra.scss");
require("../style/umb-blockgrid.css");
require("../style/bootstrap.scss");
require("./lib/fetchHelper");
require("ShiftExchangeFormComponent");
require("ShiftScheduleComponent");
require("MemberProfileFormComponent");
require("ShiftExchangeComponent");
require("EventTicketSalesComponent");
require("YellowShiftListComponent");
require("FullScheduleComponent");
require("ShiftExchangeListComponent");
require("MyShiftExchangesComponent");
require("MyShiftOffersComponent");
require("ShiftInformationComponent");
require("LoginComponent");
require('MemberListComponent');
require("TicketSalesComponent");
require("FilmStripComponent");
require("FilmComponent");
require("MemberCelebrationComponent");
require("SearchComponent");
require("MemberInboxComponent");
require("InboxBadgeComponent");
require("HomeGreetingComponent");
import { registerServiceWorker, resyncSubscription } from "./lib/pushNotifications";
window.addEventListener("load", () => {
    registerServiceWorker().then(() => {
        // Only logged-in members get the inbox badge, and only they can re-register a subscription.
        // The top bar's badge comes first in the page; the bottom bar's only shows the count.
        const badge = document.querySelector(".inboxbadgecomponent");
        if (badge === null || badge === void 0 ? void 0 : badge.dataset.memberkey)
            resyncSubscription(badge.dataset.memberkey);
    });
});
